﻿import { mapGetters, mapState } from 'vuex';
import mixins from './mixins.js';
import popupMessage from './popupMessage.vue';

export default {
    name: 'ca-contracts-signature',
    mixins: [mixins],
    props: ['viewmodel'],
    components: {
        'ca-popup-message': popupMessage
    },
    mounted() {
    },
    data: () => ({
        imgWidth: "0",
        imgHeight: "0",
        canvasObj: '',
        canvasContext: '',
        active: false,
        showCanvas: false,
        showSignatureButton: true
    }),
    methods: {
        digitalSigning(isDigital) {
            if (isDigital) {
                this.active = true;
                this.validateForm("True");

                if (this.digitalSigningModal.multipleSignatures) {
                    const dialogData = {
                        headline: this.viewmodel.getDigitalSignatureModalTitle,
                        message: this.viewmodel.getDigitalSignatureModalMessage,
                        signLoaderTitle: this.viewmodel.getSubmitOrderLoaderTitle,
                        signLoaderMessage: this.viewmodel.getSubmitOrderLoaderMessage,
                        digitalSignatureLabels: {
                            'name': this.viewmodel.getDigitalSignatureNameLabel,
                            'contracts': this.viewmodel.getDigitalSignatureContractsLabel,
                            'sign': this.viewmodel.getDigitalSignatureSignLabel
                        }
                    };

                    this.$store.dispatch('showDigitalSigningDialog', dialogData);
                } else {
                    this.signNow();
                }
            } else {
                this.showCanvas = false;
                this.active = false;

                const dialogData = {
                    headline: this.viewmodel.getManualSignatureModalTitle,
                    message: this.viewmodel.getManualSignatureModalMessage,
                    signLoaderTitle: this.viewmodel.getSubmitOrderLoaderTitle,
                    signLoaderMessage: this.viewmodel.getSubmitOrderLoaderMessage
                };

                this.$store.dispatch('showManualSigningDialog', dialogData);
            }
        },
        validateForm(state) {
            var validateElement = document.getElementById('ContractsSignitureCreditAccountBlock_ValidateSignature');
            validateElement.value = state;
        },
        enableSigning: function () {
            if (this.order.useNewDiva) {
                return !((this.hasAnyTeliaContract == this.contracts.checkCTC) &&
                    this.validateEmails());
            }
            else {
                return (!(this.contracts.checkCTC && (this.showTFSummaryInformation == this.contracts.checkCTFC) && this.validateEmails()));
            }
        },
        validateEmails: function () {
            if (this.contracts.validEmails) {
                return true;
            } else {
                return false;
            }
        }
    },
    computed:
        Object.assign(
            mapState({
                order: state => state.creditaccount.order,
                contracts: state => state.creditaccount.contracts,
                showTFSummaryInformation: state => state.creditaccount.showTFSummaryInformation,
                pageLoader: state => state.creditaccount.pageLoader,
                digitalSigningModal: state => state.creditaccount.digitalSigningModal,
                salesChannel: state => state.creditaccount.salesChannel,
                manualSigning: state => state.order.manualSigning
            }),
            mapGetters({
                showCreditAgreementDetails: 'showCreditAgreementDetails',
                hasAnyContract: 'hasAnyContract',
                hasAnyTeliaContract: 'hasAnyTeliaContract'
            })
        )
}
